import Vue from 'vue'
// https://antonioufano.com/articles/global-events-vue-nuxt/
export const GlobalEventEmitter = new Vue()